<template>
  <div
    class="modal fade"
    id="stateChagePayment"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog  modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header"
          style="padding: 25px 77px; border-bottom: none !importante"
        >
          <h5
            class="modal-title"
            id="exampleModalLabel"
            style="font-size: 25px; font-weight: 500"
          >
            {{ $t('empresa.reservas.p50') }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="far fa-times"></i>
          </button>
        </div>
        <div class="modal-body" style="padding: 10px 77px" v-if="$parent.datosReserva">
          <br />

          <strong> {{ $t('empresa.reservas.p51') }}</strong>
          <br />
          <br />

          <div class="form-group">
              <select name="" id="" class="custom-select " style="    height: 52px;
    font-weight: 700;" v-model="$parent.datosReserva.payment">
                 <option value="#" selected disabled> {{ $t('empresa.reservas.p52') }}</option>
                 <option :value="0"> {{ $t('empresa.reservas.p53') }}</option>
                 <option :value="1"> {{ $t('empresa.reservas.p54') }}</option>
              </select>
          </div>
        </div>
        <div
          class="modal-footer"
          style="padding: 25px 77px; border-top: none !importante"
        >
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            {{ $t('empresa.reservas.p55') }}
          </button>
          <button
            @click.prevent="cambiarStatadoPaymet()"
            type="button"
            class="btn btn-success"
          >
          {{ $t('empresa.reservas.p56') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {};
  },
  methods: {
    cambiarStatadoPaymet() {
      // if (!this.$parent.datosReserva.payment) {
      //   toastr.error("Debe seleccionar el estado del pago de la reserva");
      //   return;
      // }
      this.$store.state.loader = true;
      let url = this.$base.dominio + "/update/state/paymet";
      const datos = {
        reserva_id: this.$parent.datosReserva.id,
        payment:this.$parent.datosReserva.payment
      };
      axios
        .post(url, datos)
        .then((res) => {
          this.$parent.datosReserva.payment = res.data.payment
          $("#stateChagePayment").modal("hide");
          // this.$parent.listarHabitaciones();
          this.$store.state.loader = false;
        })
        .catch((e) => {
          console.log("e", e);
          this.$store.state.loader = false;
        });
    },
  },
};
</script>
